// Modules
import React from 'react';
import _ from 'lodash';

import { RawField, TextInput } from 'components/forms/form-elements';
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import { debounceWithCancellation } from 'utils/promise-utils';
import { shortDate } from 'utils/format-utils';
import Ticket from 'services/data/ticket';

export default class TicketSelector extends React.Component {
  constructor() {
    super();

    this.state = { tickets: [], fetching: true };
    this.selectTicket = this.selectTicket.bind(this);
    this.debouncedSearch = debounceWithCancellation(this.search.bind(this));
    this.runSearch = (event) => {
      this.setState({ fetching: true });
      this.debouncedSearch(event.target.value);
    };
  }

  componentDidMount() {
    this.search();
  }

  search(search) {
    const { company } = this.props;
    const query = { where: { company: company.id }, limit: 10, sort: ['closedAt desc', 'createdAt desc'] };

    if (search) query.where.search = search;

    return Ticket.find(query)
      .then(tickets => {
        this.setState({ tickets, fetching: false });
      });
  }

  selectTicket(ticket) {
    this.props.onSelect(ticket);
  }

  render() {
    const { tickets, fetching } = this.state;

    const scrollableStyles = {
      height: '300px',
      overflowY: 'scroll',
      width: '250px'
    };

    return (
      <div>
        <div className="p-2"><RawField autoFocus elementClasses="mb-0" onChange={this.runSearch} component={TextInput} /></div>
        <div className="border-rounded" style={scrollableStyles}>
          { fetching && <div className="d-flex h-100 w-100 align-items-center justify-content-center"><RoundLoader color="#34495e" /></div> }
          <div className="list-group list-group-flush">
            { _.map(tickets, ticket =>
              <a
                className="list-group-item list-group-item-action"
                key={ticket.id}
                onClick={() => this.selectTicket(ticket)}
              >
                { !ticket.closedAt &&
                  <div>
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ticket.description}</div>
                    <div>Opened: {shortDate(ticket.createdAt)}</div>
                  </div>
                }
                { ticket.closedAt &&
                  <div className="text-muted">
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ticket.description}</div>
                    <div>Closed: {shortDate(ticket.closedAt)}</div>
                  </div>
                }
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/widgets/selectors/ticket-selector.js